

export default function getGridIndexListItemByXYOrNull<T>(
  gridWidth: number,
  gridHeight: number,
  list: Array<T>,
  x: number,
  y: number,
): T | null {
  if ((x >= 0 && x < gridWidth && y >= 0 && y < gridHeight)) {
    const gridIndex = x + (y * gridWidth)
    return list[gridIndex]
  }
  return null
}